
import { v4 as uuidv4 } from 'uuid';
import api from "@/utils/api";
import { saveData, loadData, removeData } from "@/utils/storageHelper";

export default {
    namespaced: true,
    state() {
        return {
            terminalAuthenticated: false,
            terminalDetails: loadData('terminalDetails') || {
                name: '',
                locationId: '',
            },
            locationId: loadData('locationId') || null,
            apiToken: loadData('apiToken'),
            deviceId: loadData('deviceId'),
            registrationError: '',
        }
    },
    getters: {
        terminalAuthenticated: state => state.terminalAuthenticated,
        terminalDetails: state => state.terminalDetails,
        locationId: state => state.locationId,
        apiToken: state => state.apiToken,
        deviceId: state => state.deviceId,
        registrationError: state => state.registrationError,
    },
    mutations: {
        SET_AUTHENTICATED(state, status) {
            state.terminalAuthenticated = status;
        },
        SET_TERMINAL_DETAILS(state, details) {
            state.terminalDetails = { ...state.terminalDetails, ...details };
            saveData('terminalDetails', state.terminalDetails);
        },
        SET_API_TOKEN(state, token) {
            state.apiToken = token;
            saveData('apiToken', token);
        },
        SET_LOCATION_ID(state, locationId) {
            state.locationId = locationId;
            saveData('locationId', locationId);
        },
        SET_DEVICE_ID(state, deviceId) {
            state.deviceId = deviceId;
            saveData('deviceId', deviceId);
        },
        SET_REGISTRATION_ERROR(state, error) {
            state.registrationError = error;
        },
    },
    actions: {
        async registerTerminal({ commit, state, dispatch }, { pin }) {
            let deviceId = state.deviceId || uuidv4();
            commit('SET_DEVICE_ID', deviceId);

            try {
                const response = await api.callAPI("POST", "terminal/register", { token: pin, deviceId });

                if (response.status === 200) {
                    const { terminal, apiToken } = response.data;
                    commit("SET_API_TOKEN", apiToken);
                    commit("SET_TERMINAL_DETAILS", terminal);
                    commit('SET_LOCATION_ID', terminal.location_id);
                    commit('SET_AUTHENTICATED', true);
                    commit('SET_REGISTRATION_ERROR', '');
                    await dispatch("initializeLocation", null, { root: true });
                } else {
                    commit('SET_REGISTRATION_ERROR', response.data.error || 'Unexpected response from the server');
                }
            } catch (error) {
                const errorMessage = {
                    400: 'Bad request: Missing or invalid data',
                    401: 'Invalid token',
                    403: 'Forbidden: Terminal not authorized',
                    500: 'Internal server error',
                }[error.response?.status] || 'An error occurred during registration';
                commit('SET_REGISTRATION_ERROR', errorMessage);
            }
        },
        async deregisterTerminal({ commit, state }) {

            await api.callAPI("POST", "terminal/deregister", null, state.apiToken);


            commit('SET_AUTHENTICATED', false);
            commit('SET_API_TOKEN', null);
            commit('SET_DEVICE_ID', null);
            removeData('apiToken');
            removeData('deviceId');
            commit('SET_TERMINAL_DETAILS', {
                name: '',
                locationId: '',
            });
            removeData('terminalDetails');

        },
    },
};
